export default __webpack_public_path__ + "static/media/earth.247c7b29.png";